import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ICcyPromiseLookupService } from "../ICcyPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class CcyPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.CurrencyImpl>
  implements ICcyPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getCcy(code: string): Promise<CubiqTS.CurrencyImpl>;
}
